import AddIcon from "@/components/icons/AddIcon";
import MinusIcon from "@/components/icons/MinusIcon";
import Link from "next/link";

const AboutUs = ({ t, active, setActive }) => {
  return (
    <div className="col-span-full md:col-span-6 lg:col-span-3">
      <h2 className="hidden font-bold uppercase md:block">{t("About Us")}</h2>
      <div
        onClick={() => setActive(active === "about" ? null : "about")}
        className="flex items-center justify-between text-white cursor-pointer md:hidden"
      >
        <h2 className="font-bold uppercase">{t("About Us")}</h2>
        {!active || active !== "about" ? (
          <AddIcon className="size-3" />
        ) : (
          <MinusIcon className="size-3" />
        )}
      </div>
      <ul
        className={`${
          active !== "about" ? "hidden" : "block"
        } mt-3 md:block md:mt-6 max-sm:*:mb-3 *:mb-2 last:*:mb-0`}
      >
        <li>
          <Link prefetch={false} href="/about-us">
            {t("Ahmed Abdulwahed Abdullah Anam & partners")}
          </Link>
        </li>
        <li>
          <Link prefetch={false} href="/mission-and-values">
            {t("Our Mission & Values")}
          </Link>
        </li>
        {/* <li>{t("Career")}</li> */}
        <li>
          <Link prefetch={false} href="/brands">
            {t("Our Brands")}
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default AboutUs;
